<template>
  <button type="button" tabindex="0" :title="labelText" :aria-label="labelText"
          class="btn btn-link social-media-icon" :class="{'d-md-none': channelSettings.mobileOnly}"
          @click="openShareBox">
    <i :class="cssClass" />
  </button>
</template>

<script>
import kebabCase from 'lodash/kebabCase'
import { trackShareOpen } from '@/analytics/track'
import UrlSharingMixin from './url-sharing-mixin'

export default {
  mixins: [UrlSharingMixin],

  props: {
    channelSettings: {
      type: Object,
      required: true
    },

    entityType: {
      type: String,
      required: true
    },

    entitySlug: {
      type: String,
      required: false
    },

    iconClass: {
      type: String,
      required: false
    },

    shareUrlFromUrl: {
      type: Function,
      required: true
    },

    utmMedium: {
      type: String,
      required: false
    }
  },

  computed: {
    cssClass() {
      return this.iconClass || `icon-${kebabCase(this.kind)}`
    },

    kind() {
      return this.channelSettings.kind
    },

    labelText() {
      return this.i18n.t(`public.social.share_on_${this.channelSettings.medium}`)
    },

    utmSource() {
      return this.channelSettings.utmSource
    }
  },

  methods: {
    openShareBox() {
      // Track analytics
      trackShareOpen(this.kind, this.entityType, this.entitySlug)

      const url = this.shareUrlFromUrl(this.urlToShareWithTracking())
      window.open(url, 'sharer', 'toolbar=0,status=0,width=626,height=436')
    }
  }
}
</script>

<style scoped lang="scss">
  button.btn-link {
    padding: 0;
  }
</style>
